import bash from "refractor/bash";
export default bash;